exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#infobox {\n  top: .5em;\n  right: .5em;\n}\n.navigator button {\n  border: 2px solid #eee;\n  /* Green */\n  border-radius: 50%;\n  padding: 2px 4px;\n}\n.navigator button:focus {\n  outline: none;\n}\n", ""]);

// exports
